import { SVGProps, Ref, forwardRef } from 'react';

export const OkSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M12.003 11.918a5.43 5.43 0 0 0 3.864-1.595 5.46 5.46 0 0 0 1.595-3.864 5.43 5.43 0 0 0-1.595-3.864A5.43 5.43 0 0 0 12.003 1a5.43 5.43 0 0 0-3.864 1.595 5.43 5.43 0 0 0-1.595 3.864c0 1.512.605 2.874 1.595 3.864a5.5 5.5 0 0 0 3.864 1.595m-1.746-7.22a2.47 2.47 0 0 1 1.746-.728c.688 0 1.306.275 1.746.729.454.454.729 1.072.729 1.746a2.44 2.44 0 0 1-.729 1.746 2.47 2.47 0 0 1-1.746.729 2.42 2.42 0 0 1-1.746-.729 2.47 2.47 0 0 1-.729-1.746c0-.674.275-1.293.729-1.746"
                fill="currentColor"
            />
            <path
                d="m19.345 14.118-1.608-2.187c-.097-.123-.262-.137-.385-.041-1.513 1.292-3.37 2.117-5.363 2.117s-3.85-.838-5.362-2.117a.27.27 0 0 0-.385.041l-1.595 2.187a.255.255 0 0 0 .04.343c1.348 1.1 2.916 1.829 4.552 2.214l-3.382 5.954A.26.26 0 0 0 6.09 23h3.314a.25.25 0 0 0 .234-.151l2.365-5.28 2.365 5.28a.25.25 0 0 0 .234.151h3.313c.193 0 .317-.206.22-.371l-3.382-5.954a11.2 11.2 0 0 0 4.537-2.214c.11-.082.124-.234.055-.344"
                fill="currentColor"
            />
        </g>
    </svg>
));
OkSolidSize24Glyph.displayName = 'OkSolidSize24Glyph';
